import useCounter from "./useCounter";

export default function StatItem({ value, suffix, label, active }: { value: number; suffix: string; label: string; active: boolean; }) {
    const n = useCounter(value, active);

    return (
        <div className="relative py-8 px-6 sm:py-10 sm:px-8 overflow-hidden text-center sm:text-left">
            <img src="/courbes.svg" alt="" aria-hidden="true" className="absolute top-0 left-0 w-20 h-20 opacity-40 pointer-events-none select-none" />
            <div className="relative z-10 font-serif text-white leading-none mb-1.5" style={{ fontSize: 'clamp(1.9rem,5vw,3rem)' }}>{n.toLocaleString('fr-FR')}{suffix}</div>
            <div className="relative z-10 font-sans text-white/45 text-sm sm:text-base tracking-wide leading-snug">{label}</div>
        </div>
    );
}
